import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { AccountDetailsPanelComponent } from './lib/account-details-panel.component'
import { AccountDetailsKey } from './panel-key'

export * from './panel-key'
export * from './lib/account-details.module'

export const AccountDetailsPanelConfig: PanelConfig = {
  key: AccountDetailsKey,
  title: 'Account Details',
  description:
    'View details for a selected account, including identifying information and transports.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: AccountDetailsPanelComponent,
  accessPermission: 'accessAccountDetailsPanel',
}
